export const FUND_SETUP_SECTION_IDS = {
  BASIC_INFO_COMPANY: 910002,
  BASIC_INFO_FUND: 910003,
  ENTITY_SUSTAINABILITY_APPROACH: 910004,
  STRATEGY_SELECTION: 910005,
  SUSTAINABILITY_RISK: 910006,
  PAI: 910007,
  KFW: 910008,
  GENERAL_KPIS: 910009,
  HIDDEN_KPIS: 910010,
  ES_CHARACTERISTIC: 910011,
  SUSTAINABLE_OBJECTIVE_TEMPLATE: 910012,
  SUSTAINABLE_OBJECTIVE_LIST: 910013,
} as const
